import React from 'react'
import { Link } from 'react-router-dom'
// import { Select } from 'antd'
//import { Switch } from 'antd'
import { StyledHeader } from './styled'
import * as _ from 'lodash'
import { connect } from 'react-redux'
import { updateUserType } from 'Actions/user-actions'

// import { userType } from 'Common/constants'

const styles = {
  link: {
    // fontFamily: 'Arial, sans-serif',
    fontSize: '20px',
    textTransform: 'uppercase',
    color: '#66cc33',
    fontWeight: 'bold',
    textDecoration: 'none'
  },
  user: {
    color: '#6f6f6f',
    fontSize: '18px',
    // fontFamily: 'Arial, sans-serif'
  },
  userId: {
    display: 'block'
  }
}

const HeaderComponent = props => (
  <StyledHeader>
    <div style={{ position: 'relative' }}>
      <Link to="/" style={styles.link}>Modulo Resi</Link>
      <div style={{
        position: 'absolute',
        lineHeight: '1',
        bottom: '3px',
        left: '1px',
        fontSize: '10px'
      }}>
        <span>BE v.{window.backendApplicationVersion}</span>&nbsp;-&nbsp;
        <span>FE v.{window.frontendAppVersion}</span>
      </div>
    </div>
    {/* Switch used only for demo purpose. The user infos will arrive from the login */}
    {/* When the login will work, the header could be disconnected from Redux store */}
    {/*<Switch*/}
    {/*checkedChildren={userType.S.label}*/}
    {/*unCheckedChildren={userType.PM.label}*/}
    {/*defaultChecked={props.user.type === userType.S.key}*/}
    {/*onChange={checked =>*/}
    {/*props.updateUserType(checked ? userType.S.key : userType.PM.key)*/}
    {/*}*/}
    {/*/>*/}
    <div><span style={styles.user}>{_.get(props, ['user', 'data', 'data', 'first_name'], null) + ' ' + _.get(props, ['user', 'data', 'data', 'last_name'], null)}</span>
         <div style={{
        position: 'relative',
        lineHeight: '1',
        top: '-15px',
        left: '1px', 
        fontSize: '10px'
      }}>{_.get(props, ['user', 'data', 'data', 'title'], null) }</div>
    </div>
  </StyledHeader>
)

const mapStateToProps = state => {
  return {
    user: state.User
  }
}

const mapDispatchToProps = {
  updateUserType
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderComponent)



// WEBPACK FOOTER //
// ./src/components/Header/index.js